import { CircleIcon, Volume2Icon, XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { QuizResult } from "@/types/common";

type WordCardProps = {
  number: number;
  result: QuizResult;
  onSpeak: () => void;
};

export function WordCard({
  number,
  result: {
    question: { word, meaning, options },
    selectedOptionIndex,
    isCorrect,
  },
  onSpeak,
}: WordCardProps) {
  const isMissed = selectedOptionIndex === null;
  const selectedWord = !isCorrect && selectedOptionIndex !== null ? options[selectedOptionIndex] : null;

  return (
    <div className="flex flex-row items-center gap-3 rounded-xl bg-card p-4">
      <div className="flex items-center shrink-0 mr-1">
        {isCorrect ? <CircleIcon className="size-5 text-primary" /> : <XIcon className="size-5 text-secondary" />}
      </div>

      {/* 번호 */}
      <span className="w-5 text-sm font-bold text-muted-foreground shrink-0 text-center">{number}</span>

      {/* 단어 */}
      <div className="flex-1 min-w-0">
        <p className="font-bold text-foreground text-base mb-1">{word}</p>
        {isMissed ? (
          <>
            <p className="text-sm text-red-400 font-semibold">미입력</p>
            <p className="text-sm text-primary font-semibold break-keep">({meaning})</p>
          </>
        ) : isCorrect ? (
          <p className="text-sm text-slate-500 font-semibold break-keep">{meaning}</p>
        ) : (
          <>
            <p className="text-sm text-slate-500 font-semibold break-keep">{selectedWord}</p>
            <p className="text-sm text-primary font-semibold break-keep">({meaning})</p>
          </>
        )}
      </div>

      {/* 음성 재생 버튼 */}
      <div className="flex items-center gap-1 shrink-0">
        <Button variant="ghost" size="icon" className="size-8" onClick={onSpeak}>
          <Volume2Icon className="size-5 text-muted-foreground" />
        </Button>
      </div>
    </div>
  );
}
